module.exports = __webpack_public_path__ + "img/block-2.dd90e2a4.png";